import moment from 'moment';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import { crushFilters, formatDateParameters } from '../utils/DataAccessUtils';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

type ReportingModule = 'spend' | 'work';

const reportingBasePath = (userType: string, module: ReportingModule) => {
	if (module === 'spend') {
		return `/api/v1/${userType}/invoice/invoice_reportings`;
	}
	return `/api/v1/${userType}/work_order/work_order_reportings`;
};

/**
 * Fetches breakdown reporting data without updating Redux — used for comparison-period charts only.
 */
const fetchBreakdownReportingSilent =
	(module: ReportingModule, apiSubstring: string) =>
	(userType: string) =>
	(params: Record<string, any>): Promise<any[]> => {
		const startDate = params.startDate;
		const endDate = params.endDate;
		if (!startDate || !endDate) {
			return Promise.resolve([]);
		}

		let queryParams = { ...params };
		delete queryParams.startDate;
		delete queryParams.endDate;
		queryParams = formatDateParameters(queryParams);

		if (queryParams.locationIds && queryParams.locationIds.length === 0) {
			delete queryParams.locationIds;
		}
		if (queryParams.supplierFacilityIds && queryParams.supplierFacilityIds.length === 0) {
			delete queryParams.supplierFacilityIds;
		}
		if (queryParams.areaHierarchyNames && queryParams.areaHierarchyNames.length === 0) {
			delete queryParams.areaHierarchyNames;
		}

		let queryUri = baseUrl + reportingBasePath(userType, module) + '/' + apiSubstring;
		queryUri += `/${moment(startDate).format('YYYY-MM-DD')}/${moment(endDate).format(
			'YYYY-MM-DD'
		)}`;

		return fetchUtils
			.get(
				queryUri,
				Object.assign(
					{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
					crushFilters(queryParams)
				)
			)
			.then(parseJSON)
			.then(({ json, status, ok }) => {
				const responseBody = json;
				if (!ok || responseBody.status === 'error') {
					return Promise.reject(responseBody.message);
				}
				return responseBody.data || [];
			});
	};

export const fetchSpendBreakdownComparisonSilent = (apiSubstring: string) =>
	fetchBreakdownReportingSilent('spend', apiSubstring);

export const fetchWorkBreakdownComparisonSilent = (apiSubstring: string) =>
	fetchBreakdownReportingSilent('work', apiSubstring);
